import { Trash2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';

interface Props extends TRuleEditorCommonProps {
  index: number;
  canRemove: boolean;
  onRemove: () => void;
  children: ReactNode;
}

const RuleCondition = ({ index, isReadOnly, canRemove, onRemove, children }: Props) => {
  const { t } = useTranslation('Templates');

  return (
    <div>
      <div className="group flex flex-row justify-center">
        <strong>{t('question.ruleConditions.conditionIndexLabel', { index: index + 1 })}</strong>

        <div className="hubert-vertical-center ml-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          {!isReadOnly && canRemove ? (
            <Trash2 className="text-danger-400 h-4 w-4 cursor-pointer" onClick={onRemove} />
          ) : null}
        </div>
      </div>

      {children}
    </div>
  );
};

export default RuleCondition;
